var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99959 5.64111C8.66959 5.64111 7.58859 6.72311 7.58859 8.05311C7.58859 9.38211 8.66959 10.4631 9.99959 10.4631C11.3296 10.4631 12.4116 9.38211 12.4116 8.05311C12.4116 6.72311 11.3296 5.64111 9.99959 5.64111ZM9.99959 11.9631C7.84259 11.9631 6.08859 10.2091 6.08859 8.05311C6.08859 5.89611 7.84259 4.14111 9.99959 4.14111C12.1566 4.14111 13.9116 5.89611 13.9116 8.05311C13.9116 10.2091 12.1566 11.9631 9.99959 11.9631Z",
    fill: "#9E9E9E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_278_182",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 17
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000152588 0H20V16.105H0.000152588V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_278_182)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5699 8.05226C3.4299 12.1613 6.5629 14.6043 9.9999 14.6053C13.4369 14.6043 16.5699 12.1613 18.4299 8.05226C16.5699 3.94426 13.4369 1.50126 9.9999 1.50026C6.5639 1.50126 3.4299 3.94426 1.5699 8.05226ZM10.0019 16.1053H9.9979H9.9969C5.8609 16.1023 2.1469 13.2033 0.0609026 8.34826C-0.0200974 8.15926 -0.0200974 7.94526 0.0609026 7.75626C2.1469 2.90226 5.8619 0.00326172 9.9969 0.000261719C9.9989 -0.000738281 9.9989 -0.000738281 9.9999 0.000261719C10.0019 -0.000738281 10.0019 -0.000738281 10.0029 0.000261719C14.1389 0.00326172 17.8529 2.90226 19.9389 7.75626C20.0209 7.94526 20.0209 8.15926 19.9389 8.34826C17.8539 13.2033 14.1389 16.1023 10.0029 16.1053H10.0019Z",
    fill: "#9E9E9E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/Show.2c3bcbd39d6516dd58bb62dbcd1b7a0a.svg";
export { ForwardRef as ReactComponent };